import { IEntity } from '@pf/shared-common';
import {
    CarrierFragment,
    ReceiptHeaderSearchRequestParams,
    ReceiptHeaderViewModelCreateBody,
    ReceiptHeaderViewModelRead,
    ReceiptStatus,
    ResourceAuth,
    VendorFragment,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import { CustomFieldDto } from '@pf/shared/util-platform';
import { ReceiptLineDto } from './receipt-line.dto';

export type ReceiptHeaderRead = ReceiptHeaderViewModelRead & IEntity;
export type ReceiptHeaderCreate = ReceiptHeaderViewModelCreateBody;
export type ReceiptHeaderSearchParams = ReceiptHeaderSearchRequestParams;

export class ReceiptHeaderDto implements IEntity {
    constructor(data: Partial<ReceiptHeaderDto>) {
        Object.assign(this, data);
    }
    id!: string;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    dateReceived?: string;
    status!: ReceiptStatus;
    receivedByUser?: string | null;
    modifiedByUser?: string | null;
    loadReferenceNumber?: string | null;
    poNumber?: string | null;
    billOfLading?: string | null;
    trailerNumber?: string | null;
    asnHeaderId?: string | null;
    resourceAuth?: ResourceAuth;
    externalReferenceId?: string | null;
    receiptLines?: ReceiptLineDto[];
    warehouse?: WarehouseFragment;
    carrier?: CarrierFragment;
    vendor?: VendorFragment;
    loadId?: string | null;
    customFields?: Array<CustomFieldDto> | null;
    isReceived?: boolean;
}
